import { render, staticRenderFns } from "./itemTaskInfo.vue?vue&type=template&id=8b720044&scoped=true&"
import script from "./itemTaskInfo.vue?vue&type=script&lang=js&"
export * from "./itemTaskInfo.vue?vue&type=script&lang=js&"
import style0 from "./itemTaskInfo.vue?vue&type=style&index=0&id=8b720044&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b720044",
  null
  
)

export default component.exports